export default `
  type LikertScaleOption {
    label: String!
    numericValue: Int!
    order: Int!
    scaleOptionID: String!
  }

  type LikertScaleStatement {
    label: String!
    order: Int!
    statementID: String!
  }

  type LikertScaleResponse {
    statementID: String!
    selectedScaleOptionID: String!
  }

  type LikertScaleAnswer {
    responses: [LikertScaleResponse]
    hasSubmitted: Boolean
    answeredDate: DateTime
  }

  type LikertScale implements Block {
    id: ID!
    prompt: String!
    description: String
    required: Boolean
    showNumbers: Boolean
    scale: [LikertScaleOption]
    statements: [LikertScaleStatement]
    answer: LikertScaleAnswer @scope(type: USER)
  }
`
